import { EVENT_TYPES } from '@/components/_shared/Form/Validation/FieldValidator.vue'

export default {
  validations: {
    type: Array,
    default: () => [],
    validator(value) {
      // validation.errorMessage is optional
      return value.every(validation => typeof validation === 'object' && validation.validator)
    },
  },
  setHasErrorOn: {
    type: Array,
    default: () => [EVENT_TYPES.demand],
  },
}
